import { View } from '../../../Models/View';

export enum ViewsActionType {
  REQUEST_VIEWS = 'REQUEST_VIEWS',
  RECEIVE_VIEWS = 'RECEIVE_VIEWS',
}

export type ViewsAction = IRequestViewsAction | IReceiveViewsAction;

export interface IRequestViewsAction {
  type: ViewsActionType.REQUEST_VIEWS;
  applicationId: string;
}

export interface IReceiveViewsAction {
  type: ViewsActionType.RECEIVE_VIEWS;
  views: View[];
}
